import { render, staticRenderFns } from "./address-base-form.vue?vue&type=template&id=4bd38672"
import script from "./address-base-form.vue?vue&type=script&lang=js"
export * from "./address-base-form.vue?vue&type=script&lang=js"
import style0 from "./address-base-form.vue?vue&type=style&index=0&id=4bd38672&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports